
export default {
    props: ['product'],
    data() {
        return {
            loaded: false,
            state: false,
        }
    },
    mounted() {
        this.getState();
    },
    methods: {
        async getState(){
            try{
                const {data: response} = await this.$axios.post('api/v1/cabinet/favorite-status', {
                    id: this.product,
                });
                this.loaded = true;
                this.state = response;
            } catch (e) {
            }
        },
        async favorite(){
            this.loaded = false;
            try{
                const {data: response} = await this.$axios.post('api/v1/cabinet/favorite-change', {
                    id: this.product,
                });
                this.loaded = true;
                this.state = response;
            } catch (e) {
            }
        },

    },
}
